<div [hidden]="!isOpen">
    <div class="sc-modal__overlay" (click)="isCloseOutside && close()">
        <div class="sc-modal sc-scroll-bar"
            [class.sc-modal--small]="size==='small'"
            (click)="handleModalClick($event)">
            <div class="sc-modal__header-wrapper">
                <ng-content select=".sc-modal__header"></ng-content>
                <button
                    *ngIf="closeButton"
                    #closeButtonElement
                    class="sc-modal__close"
                    aria-label="Close"
                    tabindex="0"
                    [disabled]="closeDisabled"
                    (click)="close()"
                >
                    <span class="sc-modal__close-icon icon-close-elipse"></span>
                </button>
            </div>
            <div class="sc-modal__body" #content>
                <ng-content></ng-content>
            </div>
        </div>
    </div>
    <div tabindex="0" class="sc-modal__focus-trap-anchor" (focus)="handleEndAnchorTrapFocus()"></div>
</div>
